import React, { Component } from 'react';
import { Table, DatePicker, Input, Select, Button, Popconfirm, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import LoseRecord from './LoseRecord';
import API_URL from '../../../common/url';
import moment from 'moment';

const { Option } = Select;
const dateFormat = 'YYYY-MM-DD';

class Filter extends Component {
    state = {
        searchParams: {}
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({...searchParams});
    }

    export = () => {
        this.props.export();
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleDatePickerChange = (date, dateString, key) => {
        const { searchParams } = this.state;
        searchParams[key] = dateString;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    render() {
        const { searchParams: { employeeCode, userCompellation, loseTime, loseType, loseReason } } = this.state;
        const newLoseTime = loseTime ? moment(loseTime) : null;
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label className="ui-label">工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">姓名</label>
                    <Input
                        placeholder="请输入"
                        value={userCompellation}
                        onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">丢失时间</label>
                    <DatePicker
                        style={{width: 100}}
                        format={dateFormat}
                        value={newLoseTime}
                        placeholder="请选择"
                        className="w-100-select"
                        onChange={(date, dateString) => this.handleDatePickerChange(date, dateString, 'loseTime')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">丢失类型</label>
                    <Select
                        placeholder="请选择"
                        value={loseType}
                        allowClear={true}
                        style={{width: 90}}
                        onChange={value => this.handleSelectChange(value, 'loseType')}
                    >
                        <Option value="LOSE_INVESTIGATION">项目丢失</Option>
                        <Option value="LOSE_HOSPITAL">医院丢失</Option>
                        <Option value="LOSE_DEPARTMENT">科室丢失</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">丢失原因</label>
                    <Select
                        placeholder="请选择"
                        value={loseReason}
                        allowClear={true}
                        style={{width: 100}}
                        onChange={value => this.handleSelectChange(value, 'loseReason')}
                    >
                        <Option value="SERIOUS_COMPLAINTS">严重投诉</Option>
                        <Option value="UNTIMELY_HANDLING">处理不及时</Option>
                        <Option value="NEGATIVE_ATTITUDE">态度不积极</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

class Lose extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 3,
        },
        loading: false,
        data: [],
        subData: {},
        subSortParams: {},
        expandedRowKeys: [],
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryHospitalDepartmentProjectLoseUserList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                const expandedRowKeys = [];
                const values = Object.values(searchParams);
                if (values.some(i => !!i)) {
                    datas.forEach(i => expandedRowKeys.push(i.userId));
                }

                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                    expandedRowKeys,
                    subSortParams: {},
                }, () => {
                    expandedRowKeys.forEach(i => this.loadSubData(i));
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    loadSubData = (userId) => {
        const { searchParams, subSortParams } = this.state;
        const sortParams = subSortParams[userId] || {};
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryHospitalDepartmentProjectLoseListByUserId,
            data: {
                ...searchParams,
                ...sortParams,
                userId,
            },
            dataType: 'json',
            doneResult: res => {
                const { subData } = this.state;
                subData[userId] = res.hospitalDepartmentProjectLoses;
                this.setState({
                    subData,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    subDelete = (row) => {
        const { userId, hospitalDepartmentProjectLoseId } = row;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.deleteHospitalDepartmentProjectLose,
            data: { hospitalDepartmentProjectLoseId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadSubData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    search = searchParams => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { pagination, sortParams, searchParams } = this.state;
        ExportUtil.export({ ...sortParams, ...searchParams }, pagination, API_URL.user.exportHospitalDepartmentProjectLoseList);
    }

    getColumns = () => {
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            sorter: true,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
        }, {
            title: '手机号码',
            dataIndex: 'userMobile',
            key: 'userMobile',
        }, {
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            render: (text, record) => {
                return <a onClick={() => this.showLoseRecord(record)}>添加丢失记录</a>;
            }
        }];
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map((item, index) => ({
            index: index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    onExpand = (expanded, record) => {
        const { expandedRowKeys } = this.state;
        if (expandedRowKeys.length == 0) {
            expandedRowKeys.push(record.userId);
        } else {
            if (expanded) {
                expandedRowKeys.push(record.userId);
            } else {
                expandedRowKeys.map((item, index) => {
                    if (item == record.userId) {
                        expandedRowKeys.splice(index, 1);
                    };
                });
            }
        }
        this.setState({ expandedRowKeys });
        if (expanded) {
            this.loadSubData(record.userId);
        }
    }

    getRender = (type, options) => {
        if (type === 'date') {
            return text => text ? text.slice(0, 10) : '';
        } else if (type === 'toChinese') {
            // 转中文
            const { contrastList } = options;
            return (text, record) => {
                return text ? (contrastList.find(i => i.value === text) || {}).name : '';
            }
        } else if (type == 'custom') {
            return (text, record) => {
                const { loseType, investigationName, hospitalName, departmentName } = record;
                if (loseType === 'LOSE_INVESTIGATION') {
                    return investigationName;
                } else if (loseType === 'LOSE_HOSPITAL') {
                    return hospitalName;
                } else if (loseType === 'LOSE_DEPARTMENT') {
                    return `${hospitalName}(${departmentName})`;
                }
                return text;
            }
        }
    }

    expandedRowRender = (record) => {
        const { userId } = record;
        const { subData } = this.state;
        const data = subData[userId] || [];

        const getColumns = () => {
            const columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: '丢失时间',
                dataIndex: 'loseTime',
                key: 'loseTime',
                width: 90,
                sorter: true,
                render: this.getRender('date'),
            }, {
                title: '丢失类型',
                dataIndex: 'loseType',
                key: 'loseType',
                width: 120,
                render: this.getRender('toChinese', {
                    contrastList: [{
                        value: 'LOSE_INVESTIGATION',
                        name: '项目丢失'
                    }, {
                        value: 'LOSE_HOSPITAL',
                        name: '医院丢失'
                    }, {
                        value: 'LOSE_DEPARTMENT',
                        name: '科室丢失'
                    }],
                }),
            }, {
                title: '项目简称/医院科室',
                dataIndex: 'sponsorName',
                key: 'sponsorName',
                width: 210,
                render: this.getRender('custom'),
            }, {
                title: '丢失原因',
                dataIndex: 'loseReason',
                key: 'loseReason',
                width: 150,
                render: this.getRender('toChinese', {
                    contrastList: [{
                        value: 'SERIOUS_COMPLAINTS',
                        name: '严重投诉'
                    }, {
                        value: 'UNTIMELY_HANDLING',
                        name: '处理不及时'
                    }, {
                        value: 'NEGATIVE_ATTITUDE',
                        name: '态度不积极'
                    }],
                }),
            }, {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
                width: 165,
            }, {
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 80,
                render: (text, row) => {
                    return (
                        <span>
                            <a onClick={() => this.showLoseRecord(record, row)}>修改</a>
                            <span className="ant-divider" />
                            <Popconfirm title="确定要删除吗?" onConfirm={() => this.subDelete(row)}>
                                <a>删除</a>
                            </Popconfirm>
                        </span>
                    )
                }
            }];
            return columns;
        }
    
        const getDataSource = () => {
            const dataSource = [];
            data.map((item, index) => {
                dataSource.push({
                    index: index + 1,
                    ...item,
                });
            });
            return dataSource;
        };

        const handleTableChange = (pagination, filters, sorter) => {
            const { subSortParams } = this.state;
            const sortParams = subSortParams[userId] || {};
            sortParams.sort = sorter.field;
            sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
            subSortParams[userId] = sortParams;
            this.setState({
                subSortParams,
            }, () => {
                this.loadSubData(userId);
            });
        };

        return (
            <Table
                rowKey={record => record.index}
                columns={getColumns()}
                dataSource={getDataSource()}
                pagination={false}
                scroll={{ x: 875, y: 300 }}
                onChange={handleTableChange}
            />
        );
    }

    showLoseRecord = (parentParams, params) => {
        this.loseRecordRef.show(parentParams, params);
    }

    render() {
        const { loading, pagination, expandedRowKeys } = this.state;
        return (
            <div>
                <Filter search={this.search} export={this.export} />
                <Table
                    bordered
                    loading={loading}
                    pagination={pagination}
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={row => row.userId}
                    onChange={this.handleTableChange}
                    onExpand={this.onExpand}
                    expandedRowKeys={expandedRowKeys}
                    expandedRowRender={this.expandedRowRender}
                />
                <LoseRecord ref={el => this.loseRecordRef = el} loadData={this.loadSubData} />
            </div>
        );
    }
}

export default Lose;


// WEBPACK FOOTER //
// ./src/components/user/teamManageEvaluate/Lose.js